// src/js/main.js

import $ from 'jquery';

import 'bootstrap';
import 'magnific-popup';
import 'devbridge-autocomplete';

import favHandler from './modules/favorites';
import './modules/map';

window.isInitialized = false;

window.sha256Hash = async function sha256Hash(value) {
    const data = new TextEncoder().encode(value);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
};

function handleNavigation() {
    // mobile nav
    $('#navbar-mobile').on('show.bs.collapse', function() {
        $('.hamburger').addClass('is-active');
        $('body').addClass('overlay');
    }).on('hide.bs.collapse', function() {
        $('body').removeClass('overlay');
        $('.hamburger').removeClass('is-active');
    });

    // navbar layers
    if ($('.navbar').width() > 750) {
        $('.nav .dropdown').on('mouseover', function() {
            'use strict';
            $(this).addClass('show');
        });
        $('.nav .dropdown').on('mouseleave', function() {
            'use strict';
            $(this).removeClass('show');
        });
    }
}

function handleSearch() {
    $('.search-box a').on('click', function() {
        $('.search-box .dropdown-menu').toggleClass('display-block');
        $('.search-box a i').toggleClass('fa-close').toggleClass('fa-search');
        if ($('.search-box a i').hasClass('fa-close')) {
            $('#tx-solr-searchbox').focus();
        }
    });
    $('.search-box form').on('submit', function(e) {
        if ($(this).find('#tx-solr-searchbox').val() === '') {
            e.preventDefault();
            window.location = $(this).attr('action');
        }
    });
    $('#navbar-mobile form').on('submit', function(e) {
        if ($(this).find('#tx-solr-searchbox-mobile').val() === '') {
            e.preventDefault();
            window.location = $(this).attr('action');
        }
    });
    $('#filterListCollapse').on('show.bs.collapse', function() {
        $('body').addClass('noscroll');
    }).on('hide.bs.collapse', function() {
        $('body').removeClass('noscroll');
    });
}

function handleClickEnlarge() {
    let mPtClose = 'Schliessen (Esc-Taste)';
    let mPtLoading = 'Lade Bilder...';
    let mPtPrev = 'Vorheriges Bild (linke Pfeiltaste)';
    let mPtNext = 'Nächstes Bild (rechte Pfeiltaste)';
    let mPtCounter = '%curr% von %total%';
    let mPtError = 'Das <a href="%url%">Bild</a> konnte nicht geladen werden.';

    if (document.documentElement.lang.substring(0, 2) === 'fr') {
        mPtClose = 'Fermer (touche ESC)';
        mPtLoading = 'Chargement d’images...';
        mPtPrev = 'Image précédente (touche fléchée gauche)';
        mPtNext = 'Image suivante (touche fléchée droite)';
        mPtCounter = '%curr% de %total%';
        mPtError = 'L’<a href="%url%">image</a> n’a pas pu être chargé.';
    }

    $.extend(true, $.magnificPopup.defaults, {
        tClose: mPtClose,
        tLoading: mPtLoading,
        gallery: {
            tPrev: mPtPrev,
            tNext: mPtNext,
            tCounter: mPtCounter
        },
        image: {
            tError: mPtError
        }
    });

    $('.lightbox').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            preload: [1, 2]
        },
        image: {
            titleSrc: function(item) {
                return item.el.parent().children('figcaption').text();
            }
        }
    });

    $('.magnific-slideshow').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            preload: [1, 2]
        },
        callbacks: {
            beforeOpen: function() {
                const mfp = this;
                this.items = [];
                $(this.st.el.children('div')[0]).children().each(function(i) {
                    mfp.items.push({
                        src: $(this).data('mfpSrc'),
                        type: 'image',
                        caption: $(this).data('mfpCaption')
                    });
                });
            }
        },
        image: {
            titleSrc: function(item) {
                if (item.data.caption) {
                    return item.data.caption;
                } else {
                    return '';
                }
            }
        }
    });

    $('.magnific-image').magnificPopup({ type: 'image' });

    $('.magnific-iframe').magnificPopup({ type: 'iframe' });

    $('.magnific-gallery').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true,
            preload: [1, 2]
        }
    });

    handleProductVideoGallery();
}

function handleProductVideoGallery() {
    if (window.ucDps.youtubeVideo) {
        $('.youtube-videos').each(function() {
            if ($(this).data('href')) {
                $(this).attr('href', $(this).data('href'));
                $(this).removeAttr('data-href');
                $(this).off('click');
            }
        });

        $('.youtube-videos').magnificPopup({
            type: 'iframe',
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com',
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%?rel=0'
                    }
                }
            }
        });
    } else {
        $('.youtube-videos').each(function() {
            $(this).data('href', $(this).attr('href'));
            $(this).removeAttr('href');
            $(this).on('click', function() {
                // eslint-disable-next-line no-undef
                UC_UI.showSecondLayer();
            });
        });
    }
}

function handleMoreRatingsLink() {
    $('.show-more-ratings').on('click', function() {
        $(this).hide();
        $('.rating-details').show(400);
    });
}

function handlePopover() {
    $('[data-toggle="popover"]').popover({
        trigger: 'hover'
    });
}

function handleStickyNav() {
    $('.body-wrapper').each(function() {
        const headerArea = $('.header');
        const mainArea = headerArea.children('.navbar');

        const navigation = mainArea.find('.navbar-collapse');
        const original = {
            nav_top: navigation.css('margin-top')
        };

        $(window).scroll(function() {
            if (mainArea.hasClass('bb-fixed-header') && ($(this).scrollTop() === 0 || $(this).width() < 750)) {
                mainArea.removeClass('bb-fixed-header').appendTo(headerArea);
                navigation.animate({ 'margin-top': original.nav_top }, {
                    duration: 100,
                    queue: false,
                    complete: function() {
                        headerArea.css('height', 'auto');
                    }
                });
            } else if (!mainArea.hasClass('bb-fixed-header') && $(this).width() > 750
                && $(this).scrollTop() > headerArea.offset().top + headerArea.height() - parseInt($('html').css('margin-top'), 10)) {
                headerArea.css('height', headerArea.height());
                mainArea.css({ opacity: '0' }).addClass('bb-fixed-header');
                mainArea.appendTo($('body')).animate({ opacity: 1 });

                navigation.css({ 'margin-top': '0px' });
            }
        });
    });
}

function handleRatingLinkClick() {
    $('#ta-rating-link').click(function() {
        $('html, body').animate(
            {
                scrollTop: parseInt($('#ta-rating-header').offset().top - 90 /* height of navigation header */)
            },
            800
        );
    });
}

function adaptIFrameElement(elem, consentIsGiven, noConsentMsg) {
    if (consentIsGiven) {
        if (elem.dataset.src) {
            elem.src = elem.dataset.src;
            elem.parentElement.classList.remove('no-consent');
            const noConsentInfo = elem.parentElement.querySelector('.no-consent-info');
            if (noConsentInfo) {
                noConsentInfo.remove();
            }
        }
    } else {
        if (!elem.dataset || !elem.dataset.src) {
            elem.dataset.src = elem.src;
        }
        elem.src = '';

        const noConsentInfo = document.createElement('div');
        noConsentInfo.innerHTML = noConsentMsg;
        noConsentInfo.className = 'no-consent-info';
        elem.parentElement.append(noConsentInfo);

        elem.parentElement.classList.add('no-consent');
    }
}

function handleConsentManagement() {
    //  Defined Data Processing Services
    window.ucDps = {
        googleMaps: false,
        youtubeVideo: false
    };
    //  Handle consent status changes
    window.addEventListener('onConsentStatusChange', (event) => {
        const dpsGoogleMaps = 'Google Maps';
        const dpsYoutubeVideo = 'YouTube Video';

        let consentBlockedMsg = 'Der Inhalt wurde aufgrund der gewählten <a onclick="UC_UI.showSecondLayer();">Datenschutzeinstellungen</a> blockiert.';
        if (document.documentElement.lang.substring(0, 2) === 'fr') {
            consentBlockedMsg = 'Le contenu a été bloqué en raison des <a onclick="UC_UI.showSecondLayer();">paramètres de confidentialité</a> choisis.';
        }

        if (event.detail && event.detail.event && event.detail.event === 'consent_status') {
            // GoogleMaps
            if (dpsGoogleMaps in event.detail) {
                window.ucDps.googleMaps = !!event.detail[dpsGoogleMaps];
            }
            const gmapIframes = document.querySelectorAll('iframe.gmap');
            if (gmapIframes.length) {
                gmapIframes.forEach((iFrameElem) => {
                    adaptIFrameElement(iFrameElem, window.ucDps.googleMaps, consentBlockedMsg);
                });
            }

            // YouTube
            if (dpsYoutubeVideo in event.detail) {
                window.ucDps.youtubeVideo = !!event.detail[dpsYoutubeVideo];
            }
            const ytIframes = document.querySelectorAll('iframe.yt-video');
            if (ytIframes.length) {
                ytIframes.forEach((iFrameElem) => {
                    adaptIFrameElement(iFrameElem, window.ucDps.youtubeVideo, consentBlockedMsg);
                });
            }

            handleProductVideoGallery();
        }

        // dispatch event
        const consentEvent = new CustomEvent('consentStatusSet', {});
        document.dispatchEvent(consentEvent);
    });
}

class SuggestController {
    init() {
        $('form[data-suggest]').each(function() {
            const $form = $(this);
            let $searchBox = $form.find('.tx-solr-suggest');
            const $searchIcon = $form.find('i.material-icons');
            $form.find('.tx-solr-suggest-focus').focus();
            jQuery.ajaxSetup({ jsonp: 'tx_solr[callback]' });

            // when no specific container found, use the form as container
            if ($searchBox.length === 0) {
                $searchBox = $form;
            }
            $searchBox.css('position', 'relative');

            // Prevent submit of empty search form
            $form.on('submit', function(e) {
                if ($form.find('.tx-solr-suggest').val() === '') {
                    e.preventDefault();
                    window.location = $form.attr('action');
                }
            });
            $form.find('.tx-solr-suggest').devbridgeAutocomplete({
                serviceUrl: $form.data('suggest'),
                dataType: 'jsonp',
                paramName: 'tx_solr[queryString]',
                groupBy: 'category',
                maxHeight: 320,
                autoSelectFirst: false,
                triggerSelectOnValidInput: false,
                width: $searchBox.outerWidth(),
                onSelect: function(suggestion) {
                    // go to link when selecting found result
                    if (suggestion.data.link) {
                        // Open youtube in overlay
                        if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
                            openVideoOverlay(suggestion.data.link);
                        } else {
                            location.href = suggestion.data.link;
                        }
                        // else trigger form submit (do search)
                    } else {
                        $form.trigger('submit');
                    }
                },
                transformResult: function(response) {
                    if (!response.suggestions) return { suggestions: [] };
                    let firstSuggestion;
                    const result = {
                        suggestions: $.map(response.suggestions, function(count, suggestion) {
                            if (!firstSuggestion) firstSuggestion = suggestion;
                            return { value: suggestion, data: { category: 'suggestion', count: count } };
                        })
                    };
                    $.each(response.documents, function(key, value) {
                        const dataObject = value;

                        // var defaultGroup = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';
                        dataObject.category = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';

                        // if a group is set we try to get a label
                        if (dataObject.group) {
                            dataObject.category = $form.data('suggest-header-' + dataObject.group) ? $form.data('suggest-header-' + dataObject.group) : dataObject.group;
                        }

                        result.suggestions.push(
                            {
                                value: firstSuggestion,
                                data: dataObject
                            }
                        );
                    });
                    return result;
                },
                beforeRender: function(container) {
                    // change first group header title
                    // if ( $form.data('suggest-header-suggestion') ) {
                    //    container.find('.autocomplete-group:first').html($form.data('suggest-header-suggestion'));
                    // }
                    // remove first group header
                    container.find('.autocomplete-group:first').remove();
                    container.addClass('tx-solr-autosuggest');

                    // add active class to container
                    $searchBox.parent().addClass('autocomplete-active').fadeIn();
                },
                formatResult: function(suggestion, currentValue) {
                    // Do not replace anything if there current value is empty
                    if (!currentValue) {
                        return suggestion.value;
                    }
                    const pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')';
                    // normal suggestion
                    if (suggestion.data.category === 'suggestion') {
                        return suggestion.value
                            .replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?strong)&gt;/g, '<$1>');

                        // results
                    } else {
                        const title = suggestion.data.title
                            .replace(new RegExp(pattern, 'gi'), '<em>$1</em>')
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;')
                            .replace(/&lt;(\/?em)&gt;/g, '<$1>');

                        return '<div class="autocomplete-restype ' + suggestion.data.type + '">'
                            + (suggestion.data.previewImage ? '<figure ' + (suggestion.data.hasVideo ? 'class="hasVideo"' : '') + '><img alt="" src="' + suggestion.data.previewImage + '" /></figure>' : '')
                            + '<a href="' + suggestion.data.link + '" class="internal-link">' + title + '</a>'
                            + '</div>';
                    }
                },
                onSearchStart: function(params) {
                    if (!$searchIcon.hasClass('loading')) {
                        $searchIcon.addClass('loading');
                        $searchIcon.html('<div></div><div></div><div></div><div></div>');
                    }
                },
                onSearchComplete: function(query, suggestions) {
                    $searchIcon.removeClass('loading');
                    $searchIcon.html('search');
                }
            }).on('blur', function() {
                $searchBox.parent().removeClass('autocomplete-active');
                const $box = $(this);
                setTimeout(function() {
                    $box.devbridgeAutocomplete('hide');
                }, 200);
            });
        });
    }
}

class SearchController {
    constructor() {
        this.ajaxType = 7383;
    }

    init() {
        $('body').on('click', 'a.solr-ajaxified', (e) => {
            e.preventDefault();
            this.handleClick(e.currentTarget);
        });
    }

    handleClick(link) {
        const $link = $(link);
        const container = $link.closest('.tx_solr');
        const solrParent = container.parent();
        const uri = `${$link.attr('href')}&type=${this.ajaxType}`;

        $('#filter-mobile').collapse('hide');

        $('.solr-loading').show();
        this.scrollToTopOfElement(solrParent, 75);

        $.get(uri, (data) => {
            container.replaceWith(data);
            $('body').trigger('tx_solr_updated');
        });
    }

    scrollToTopOfElement(element, deltaTop) {
        jQuery('html, body').animate({
            scrollTop: (element.offset().top - deltaTop) + 'px'
        }, 'slow');
    }

    handleSelectOptionSelection(elem) {
        let solrContainer = $('select.region-dropdown').closest('.tx_solr');
        const solrParent = solrContainer.parent();
        let uri = elem.value;
        uri += '&type=' + this.ajaxType;

        $('#filter-mobile').collapse('hide');

        $('.solr-loading').show();
        this.scrollToTopOfElement(solrParent, 75);

        jQuery.get(
            uri, // uri.href(),
            function(data) {
                solrContainer = solrContainer.replaceWith(data);
                jQuery('body').trigger('tx_solr_updated');
            }
        );
        return false;
    }
}

/**
 * Load plugins/modules async
 */
async function slickLoader() {
    const slickBanners = document.getElementsByClassName('slick-hero');
    if (slickBanners.length > 0) {
        await import(/* webpackChunkName: "inspiration" */ './plugins/inspiration');
    }
}

async function dateRangePickerLoader() {
    const dateRangePickerInputs = document.getElementsByClassName('from-control-datesingle');
    if (dateRangePickerInputs.length > 0) {
        await import(/* webpackChunkName: "daterangepicker" */ './plugins/daterangepicker');
    }
}

async function matchHeightLoader() {
    const cardCrossLink = document.getElementsByClassName('card-crosslink');
    const cardInfoGrp = document.getElementsByClassName('card');
    const cardContact = document.getElementsByClassName('card-contact');
    const homeTeaserElem = document.getElementsByClassName('home-teaser-elem');
    if (cardCrossLink.length > 0 || cardInfoGrp.length > 0 || cardContact.length > 0 || homeTeaserElem.length > 0) {
        await import(/* webpackChunkName: "matchheight" */ './plugins/matchheight');
    }
}

async function select2Loader() {
    const select2Elems = document.getElementsByClassName('facet-type-hierarchy');
    if (select2Elems.length > 0) {
        await import(/* webpackChunkName: "select2" */ './plugins/select2');
    }
}

/**
 * main entry point
 */
function workOnDom() {
    handleConsentManagement();

    handleNavigation();
    handleSearch();
    handleClickEnlarge();
    handleMoreRatingsLink();
    handlePopover();
    handleStickyNav();
    handleRatingLinkClick();

    // modules
    favHandler.init();

    // solr
    window.solrSuggestController = new SuggestController();
    window.solrSuggestController.init();

    window.solrSearchController = new SearchController();
    window.solrSearchController.init();

    // if results updated via ajax
    $('body').on('tx_solr_updated', () => {
        window.solrSuggestController.init();
        favHandler.setFavToggleState();
        favHandler.handleFavToggleClicks();
    });

    slickLoader().then(() => null).catch(() => null);
    dateRangePickerLoader().then(() => null).catch(() => null);
    matchHeightLoader().then(() => null).catch(() => null);
    select2Loader().then(() => null).catch(() => null);

    // initial triggers
    $(window).trigger('scroll');
    $(window).trigger('resize');

    // dispatch event initialization finished
    const initEvent = new CustomEvent('initialized', {});
    document.dispatchEvent(initEvent);
    window.isInitialized = true;
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => workOnDom());
} else {
    workOnDom();
}
